import React, { Component } from 'react';
import _ from 'underscore';
import { ButtonToolbar, Button } from 'react-bootstrap';
import { mixinsClassName, fetch, urls, guid, postMessage } from '../../utils';

export default class ImgThumbPreview extends Component {
    // constructor(props) {
    //     super(props);
    //     this.state = {
    //         isCommiting: false
    //     }
    // }
    _sendImg() {
        if(this.props.onSubmitThumbImg) {
            this.setState({
                isCommiting: true
            })
            this.props.onSubmitThumbImg()
        }
    }

    handleCancelThumbImg(e) {
        if(this.props.onCancelThumbImg) {
            this.props.onCancelThumbImg()
        }
    }

    handleSubmitThumbImg(e) {
        this._sendImg()
    }

    handleImgViewer() {
        let imgSrc = this.props.imgThumbPreviewSrc || '';
        if (!imgSrc) {
            return false;
        }
        postMessage('image.preview', {
            images: [imgSrc]
        })
    }
    handleEnterKey(ev) {
        if (!ev.shiftKey && ev.keyCode === 13) { //Enter
            // ev.preventDefault();
            this._sendImg()
        }
    }
    render() {
        
        return (
            <div className="component-img-thumb-preview" onKeyDown={this.handleEnterKey.bind(this)}>
                <a><img className="img-thumb" src={this.props.imgThumbPreviewSrc} onClick={this.handleImgViewer.bind(this)} /></a>
                <ButtonToolbar className="btn-tool">
                    <Button onClick={this.handleCancelThumbImg.bind(this)}>取消</Button>
                    <Button bsStyle="primary" onClick={this.handleSubmitThumbImg.bind(this)}>确定</Button>
                </ButtonToolbar>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/ui/img-thumb-preview/index.js